import { IntegrationSettingsValues, Location } from '@trnsact/trnsact-shared-types';
import { IntegrationSettingsEntry, IntegrationSettingsLocationLevelForm } from '../types';

export const getLocationIntegrationSettingsTableData = (
  location: Location,
  integrationSettingsValues?: IntegrationSettingsValues
): IntegrationSettingsLocationLevelForm => ({
  locationId: location.locationId!,
  locationName: location.locationName ?? '',
  category: location.category ?? '',
  integrationSettingsValuesId: integrationSettingsValues?.integrationSettingsValuesId || null,
  integrationSettingsValues: integrationSettingsValues
    ? {
        ...(integrationSettingsValues.integrationSettingsValues as unknown as IntegrationSettingsEntry),
      }
    : null,
});
